const registerBackgroundHandler = (): void => {};

export { registerBackgroundHandler };
